import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: ", ";\n  width: 100%;\n  margin: 0 5px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: ", ";\n  margin-left: -5px;\n  margin-right: -5px;\n  align-items: center;\n  @media (max-width: ", "px) {\n    margin-left: -15px;\n    margin-right: -15px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Button } from '../Button';
import { DRAWER_ACTION } from '../utils/testing/TestIDs';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject(), function (props) {
  return props.noHeaderContent ? '-10px' : '40px';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.sm;
});
var Action = styled(Button)(_templateObject2(), function (props) {
  return props.secondary ? '110px' : 'none';
});
export var DrawerActions = function DrawerActions(_ref2) {
  var _ref2$actions = _ref2.actions,
      actions = _ref2$actions === void 0 ? [] : _ref2$actions,
      _ref2$noHeaderContent = _ref2.noHeaderContent,
      noHeaderContent = _ref2$noHeaderContent === void 0 ? false : _ref2$noHeaderContent,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(Container, {
    noHeaderContent: noHeaderContent,
    className: className
  }, actions.map(function (action, i) {
    return /*#__PURE__*/React.createElement(Action, {
      secondary: action.secondary,
      disabled: action.disabled,
      onPress: action.handler,
      "data-testid": action.testId || "".concat(DRAWER_ACTION, "_").concat(i),
      key: "drawer-action-".concat(i)
    }, action.label);
  }));
};